// @ts-ignore this is templated via Vite at build time
export const appVersion: string = APP_VERSION;

// @ts-ignore
export const appDesktopProtocol: string = DEFINE_APP_PROTOCOL;

// @ts-ignore
export const sentryKey: string | null = DEFINE_SENTRY_TOKEN;

export const requiredMinimumDesktopVersion = '2.12.0';
